var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"appeal-tag",class:{'appeal-tag--other': _vm.other}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }